export default "__VITE_ASSET__BbKhncwZ__"